import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    color: theme.palette.primary.dark,
  },
  closeButton: {
    position: `absolute`,
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    color: theme.palette.primary.dark,
  },
})

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" className={classes.title}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    color: theme.palette.primary.dark,
  },
}))(MuiDialogContent)

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

export default function CustomizedDialogs({
  open = true,
  onClose,
  handleAccept = () => null,
  title,
  body,
  disabled = false,
  textButton = `Guardar`,
  hiddenButton = true,
  Width = `md`,
}) {
  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={Width}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          {title}
        </DialogTitle>
        <DialogContent dividers>{body}</DialogContent>
        {hiddenButton && (
          <DialogActions>
            <Button autoFocus={false} onClick={onClose} color="secondary" variant="contained">
              Cerrar
            </Button>
            <Button
              disabled={disabled}
              autoFocus={false}
              onClick={handleAccept}
              color="primary"
              variant="contained"
            >
              {textButton}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  )
}
